import "../styles/Service.css";

export default function Services() {
  return (
    <section className="services-page">

      {/* HERO */}
      <div className="services-hero">

        <div className="container">

          <h1>Our Services</h1>

          <p>
            Delivering precision manufacturing, OEM solutions,
            and quality-driven air conditioning production services.
          </p>

        </div>

      </div>

      {/* SERVICES GRID */}
      <div className="container">

        <div className="services-grid">

          <div className="service-card">
            <div className="service-icon">⚙</div>
            <h3>AC Assembly Job Work</h3>
            <p>Expert end-to-end assembly services for split and window air conditioners.</p>
          </div>

          <div className="service-card">
            <div className="service-icon">🏭</div>
            <h3>OEM Manufacturing</h3>
            <p>Contract manufacturing partner for global electronics and appliance brands.</p>
          </div>

          <div className="service-card">
            <div className="service-icon">🧪</div>
            <h3>Component Testing</h3>
            <p>Rigorous verification and functionality checks of individual AC components.</p>
          </div>

          <div className="service-card">
            <div className="service-icon">✅</div>
            <h3>Quality Inspection</h3>
            <p>SOP-based multi-stage quality control mechanisms for zero-defect production.</p>
          </div>

          <div className="service-card">
            <div className="service-icon">📦</div>
            <h3>Packaging & Dispatch</h3>
            <p>Safe packaging and efficient logistics management to OEM client locations.</p>
          </div>

          <div className="service-card">
            <div className="service-icon">💡</div>
            <h3>Custom Solutions</h3>
            <p>Tailor-made manufacturing processes to meet specific brand requirements.</p>
          </div>

        </div>

      </div>

    </section>
  );
}